import { Component, OnDestroy, HostListener } from '@angular/core';
import { SmartSubscription } from '@cpd-app/shared-module/utils/smartSubscription';
import { Subscription } from 'rxjs';

@Component({
  selector: 'cpd-base-component',
  template: ''
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class ComponentBase implements OnDestroy {
  public isGreaterThanXSmall: boolean = undefined;
  public isGreaterThanSmall: boolean = undefined;
  public isGreaterThanMedium: boolean = undefined;

  public isLessThanSmall: boolean = undefined;
  public isLessThanMedium: boolean = undefined;
  public isLessThanLarge: boolean = undefined;

  public subscriptions: SmartSubscription = new SmartSubscription();
  public windowWidth: number;

  constructor() {
    this.windowWidth = window.innerWidth;
    this.updateFlags();
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public set subscribedTo(value: Subscription) {
    this.subscriptions.add(value);
  }

  public get isMobileView(): boolean {
    return this.windowWidth < 960;
  }

  @HostListener('window:resize', ['$event'])
  public onResize(event) {
    this.windowWidth = window.innerWidth;
    this.updateFlags();
  }

  /*
    https://github.com/angular/flex-layout/wiki/Responsive-API
    breakpoint	mediaQuery
    xs	'screen and (max-width: 599px)'
    sm	'screen and (min-width: 600px) and (max-width: 959px)'
    md	'screen and (min-width: 960px) and (max-width: 1279px)'
    lg	'screen and (min-width: 1280px) and (max-width: 1919px)'
    xl	'screen and (min-width: 1920px) and (max-width: 5000px)'

    lt-sm	'screen and (max-width: 599px)'
    lt-md	'screen and (max-width: 959px)'
    lt-lg	'screen and (max-width: 1279px)'
    lt-xl	'screen and (max-width: 1919px)'

    gt-xs	'screen and (min-width: 600px)'
    gt-sm	'screen and (min-width: 960px)'
    gt-md	'screen and (min-width: 1280px)'
    gt-lg	'screen and (min-width: 1920px)'
    */
  private updateFlags() {
    const small = 600;
    const medium = 960;
    const large = 1280;

    this.isGreaterThanXSmall = this.windowWidth >= small;
    this.isGreaterThanSmall = this.windowWidth >= medium;
    this.isGreaterThanMedium = this.windowWidth >= large;

    this.isLessThanSmall = this.windowWidth < small;
    this.isLessThanMedium = this.windowWidth < medium;
    this.isLessThanLarge = this.windowWidth < large;
  }
}
